import React from 'react';

import './Daimler.scss';
import Logo from '../../components/Logo';
import Nav from '../../components/Nav';
import Masthead from '../Masthead';
import Footer from '../../components/Footer/Footer';
import About from '../About';

export default class Daimler extends React.Component {
  render() {
    return (
      <div className="Daimler">
        
        <Masthead/>
        <About
          title='One Team.<br/>Best Team.'
          supertitle='Daimler Diversity &amp; Inclusion'
          copy1='We at Daimler Trucks North America, believe that our innovative designs, superior quality, and exceptional customer value is a direct result of our diverse teams, who bring their best whole selves to work every day.'
          copy2='Through the inclusion of our employee diversity and based on the foundation of passion, respect, integrity and discipline, we, as ONE Team, BEST Team are able to thrive in current and future partnerships with our communities, suppliers, and business partners while driving us forward as the global leader in mobility.'
          />
        <Footer/>
      </div>
    );
  }
}

